// extracted by mini-css-extract-plugin
module.exports = {"form":"EquipmentForm_form__25XDl"};